import { render, staticRenderFns } from "./BuyerReturnList.vue?vue&type=template&id=29aaf678&"
import script from "./BuyerReturnList.vue?vue&type=script&lang=js&"
export * from "./BuyerReturnList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports